export const onCancel = ({ setNotAdding }) => () => setNotAdding();
